import Text from '$/components/ui/Text';
import { BillingCycle } from '$/GraphQL/schema/types';
import EDate from '$/shared/frontend/utils/EDate';
import { UpdateAddOnType } from '../AddOnsContext';
import { AddOn } from './AddOn';

export class UniversalDashboard extends AddOn {
  public get shortDescription(): string {
    return 'Track individual registrants and run analytics across all or any combo of webinars, plus answer chat for all your assigned webinars in one place.';
  }

  public get description(): string {
    return 'Track individual registrants and run analytics across all or any combo of webinars, plus answer chat for all your assigned webinars in one place.';
  }

  public image(): string | null {
    return require('$/images/logos/universal-dashboard.png').default;
  }

  public getModalMessage(
    type: UpdateAddOnType,
    billingCycle: BillingCycle,
    totalPublished: number,
    freeUntil?: EDate
  ): React.ReactElement {
    if (type === UpdateAddOnType.Subscribe && totalPublished < 2) {
      return (
        <Text.body>
          <p>You must have at least 2 active webinars to subscribe to this add-on.</p>
        </Text.body>
      );
    }

    return super.getModalMessage(type, billingCycle, totalPublished, freeUntil);
  }

  public isDisabledModalSubmit(
    type: UpdateAddOnType,
    totalPublished: number
  ): { buttonText: string } | undefined {
    if (type !== UpdateAddOnType.Subscribe) {
      return undefined;
    }
    if (totalPublished < 2) {
      return {
        buttonText: 'Got it!',
      };
    }
    return undefined;
  }
}
